/**
 * Uygulama geneli özellik bayrakları.
 *
 * Google ile giriş/kayıt: aquasoft.com.tr alan adı Google Cloud'da henüz
 * OAuth için yapılandırılmadığından geçici olarak gizlendi.
 * Yeni client ID'ler alındığında bu bayrağı `true` yapmak yeterlidir.
 */
export const GOOGLE_LOGIN_ENABLED = false;
